<template>
  <div class="container-md col-lg-11 col-md-11 review-activity pt-2">
    <div class="d-flex">
      <h4 class="text-primary w-100">
        {{ isPendingActivity ? "Candidate Review" : "Candidate Review" }}
      </h4>
      <CButton
        class="justify-content-end text-nowrap"
        color="primary"
        shape="pill"
        @click="backToList"
        >Back to list</CButton
      >
    </div>
    <div v-if="isPendingActivity" class="mt-3 mb-3">
      <ReviewActivity
        v-if="isPendingActivity"
        :activityDetails="selectedActivity"
        :comments="getComments"
        @changeActivityStatus="changeActivityStatus"
        @openCandidateInfoModal="openCandidateInfoModal"
        @openJobInfoModal="openJobInfoModal"
      />
      <h4 v-else class="text-muted p-4 text-center">
        No Pending Activity Available for Review
      </h4>
    </div>
    <div class="mt-3 mb-3" v-else>
      <CompletedCandidateReReview
        v-if="isCompletedActivity"
        :activityDetails="selectedActivity"
        :comments="getComments"
        @changeActivityStatus="changeActivityStatus"
        @openCandidateInfoModal="openCandidateInfoModal"
        @openJobInfoModal="openJobInfoModal"
      />
      <h4 v-else class="text-muted p-4 text-center">
        No completed Activity Available for Review
      </h4>
    </div>
    <CandidateInfoModal
      v-if="candidateInfoModal.isShowPopup"
      :candidate_uid="candidateInfoModal.candidate_uid"
      :isShowModal="candidateInfoModal.isShowPopup"
      :isShowContact="false"
      @modalCallBack="candidateInfoModalCallBack"
    />
    <JobInfoModal
      v-if="jobInfoModal.isShowPopup"
      :job_id="jobInfoModal.job_id"
      :isShowModal="jobInfoModal.isShowPopup"
      @modalCallBack="jobInfoModalCallBack"
    />
  </div>
</template>
<script>
import ReviewActivity from "@/containers/ActivityList/CandidateReviewer/ReviewActivity";
import CompletedCandidateReReview from "@/containers/ActivityList/CandidateReviewer/CompletedCandidateReReview";
import { mapActions, mapGetters } from "vuex";
import { isObject, isEmptyObjectCheck } from "@/helpers/helper";
import CandidateInfoModal from "@/components/reusable/CandidateInfoModal";
import JobInfoModal from "@/components/reusable/JobInfoModal";
export default {
  components: {
    ReviewActivity,
    CompletedCandidateReReview,
    CandidateInfoModal,
    JobInfoModal,
  },
  data() {
    return {
      candidateInfoModal: {
        isShowPopup: false,
        candidate_uid: null,
      },
      jobInfoModal: {
        isShowPopup: false,
        job_id: null,
      },
    };
  },
  computed: {
    ...mapGetters(["selectedActivity", "getComments", "activeTab"]),
    isPendingActivity() {
      return (
        isObject(this.selectedActivity) &&
        !isEmptyObjectCheck(this.selectedActivity) &&
        this.selectedActivity.status_id === 52 &&
        [53, 44].includes(this.selectedActivity.sub_status_id)
      );
    },
    isCompletedActivity() {
      return (
        isObject(this.selectedActivity) &&
        !isEmptyObjectCheck(this.selectedActivity) &&
        [54, 52].includes(this.selectedActivity.status_id) &&
        [50, 47].includes(this.selectedActivity.sub_status_id)
      );
    },
  },
  methods: {
    ...mapActions([
      "fetchSelectedJobActivity",
      "fetchSelectedActivityComments",
      "interviewReviewer",
      "holdReviewer",
      "disapproveReviewer",
      "queryReviewer",
    ]),
    changeActivityStatus(data) {
      const { action, payload } = data;
      switch (action) {
        case "Interview":
          this.interviewReviewer(payload);
          break;
        case "Hold/Query":
          this.holdReviewer(payload);
          break;
        case "Disapprove":
          this.disapproveReviewer(payload);
          break;
      }
    },
    backToList() {
      // this.isPendingActivity
      //   ? this.$store.commit("SET_ACTIVE_TAB", 0)
      //   : this.$store.commit("SET_ACTIVE_TAB", 1);
      this.$store.commit("SET_ACTIVE_TAB", this.activeTab);
      this.$router.push({ path: `/list-activity` });
    },
    openCandidateInfoModal(candidate_uid) {
      if (candidate_uid) {
        this.candidateInfoModal.candidate_uid = candidate_uid;
        this.candidateInfoModal.isShowPopup = true;
      }
    },
    openJobInfoModal(job_id) {
      if (job_id) {
        this.jobInfoModal.job_id = job_id;
        this.jobInfoModal.isShowPopup = true;
      }
    },
    candidateInfoModalCallBack(action) {
      this.candidateInfoModal.isShowPopup = false;
    },
    jobInfoModalCallBack(action) {
      this.jobInfoModal.isShowPopup = false;
    },
  },
  mounted() {
    const {
      params: { jobID, candidateID },
    } = this.$route;
    let job_id = jobID ? parseInt(jobID) : null;
    let candidate_uid = candidateID ? parseInt(candidateID) : null;
    let appendAction = [];
    appendAction = [
      ...appendAction,
      this.fetchSelectedJobActivity({
        job_id,
        candidate_uid,
        action_id: 18,
        status_id__in: [52, 54],
        sub_status_id__in: [53, 44, 50, 47],
      }),
    ];
    appendAction = [
      ...appendAction,
      this.fetchSelectedActivityComments({
        job_id,
        candidate_uid,
        action_id: 18,
        status_id__in: [52, 54],
        sub_status_id__in: [53, 44, 50, 47],
      }),
    ];
    Promise.all(appendAction).then((res) => {});
  },
};
</script>